import dayjs from "dayjs";

import { IndicatorModalCardTheme } from "@/@types/generics/IndicatorModalCardTheme";
import { Vaccine } from "@/@types/esus/Vaccine";

import { IndicatorModalCard } from "@/components/IndicatorModalCard";

type VaccinationCardsProps = {
	vaccine?: Vaccine;
	theme: IndicatorModalCardTheme;
	title?: string;
};

export function VaccinationCards({ vaccine, theme, title }: VaccinationCardsProps) {
	return (
		<IndicatorModalCard
			theme={theme}
			containerClassName="vaccination-cards-container my-2 h-100"
			title={title}
			subtitle={
				vaccine?.vaccine?.dateofVaccine ? (
					dayjs(vaccine.vaccine?.dateofVaccine).format("DD/MM/YYYY")
				) : (
					<span className="visibility-hidden">--/--/----</span>
				)
			}
		>
			<span>
				Profissional:
				<span className="ms-2 fs-8 text-gray-900">
					{vaccine?.vaccine.professional?.name || "NÃO INFORMADO"}
				</span>
			</span>
			<span>
				Unidade:
				<span className="ms-2 text-gray-900">
					{vaccine?.vaccine.healthUnit?.name
						? `${vaccine?.vaccine.healthUnit?.cnes}-${vaccine?.vaccine.healthUnit?.name}`
						: "NÃO INFORMADO"}
				</span>
			</span>
		</IndicatorModalCard>
	);
}
